export default __webpack_public_path__ + "static/media/alter.e1cc4130.png";